import { useGetUserLabels, useUpdateUserLabel } from "../api/labels/labels.ts"

export const useCaseUserLabels = () => {
    const { data: userLabels, isFetching } = useGetUserLabels(true)
    const { mutate: updateLabel, isPending, variables } = useUpdateUserLabel()

    return ({
        updateLabel,
        userLabels: userLabels?.tags ?? {},
        isPending,
        isFetching,
        variables
    })
}
